import React, { useState } from 'react'
import { useFormik } from 'formik'
import AddButton from '../../components/IconButton'
import CustomTableHead from '../../components/Table/TableHead'
import CustomTableBody from '../../components/Table/TableBody'
import CustomTableRow from '../../components/Table/TableRow'
import CustomTableData from '../../components/Table/TableData'
import Modal from '../../components/Modal'
import ModalClose from '../../components/Modal/ModalClose'
import addIcon from '../../assets/icons/Addimg.svg'
import ResidentService from '../../api/resident-service'
import { ResidentTypeDTO } from '../../interfaces/resident'
import CustomTable from '../../components/Table'
import CustomTableDataCTA from '../../components/Table/TableDataCTA'
import Empty from '../../assets/icons/Empty'
import { showToast } from '../../utils/toast'
import { createResidentTypeSchema } from '../../validations/createResidentType'
import EditResidentType from './EditResidentType'
import AddResidentType from './AddResidentType'
// import { SkeletonTable } from '../Loader/skeletonTableLoader'

const tableHeadData = ['Resident type', 'Levy', 'Description', 'No of Residents', '']

interface ResidentTypeProps {
  estateId: string
  currentPage: number
  setNumOfResidentType: (num: number) => void
}

const ResidentType = ({ estateId, currentPage }: ResidentTypeProps) => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [editingResidentType, setEditingResidentType] = useState<ResidentTypeDTO | null>(
    null
  )
  const [isLoading, setIsLoading] = useState(false)

  const { data, mutate } = ResidentService.useGetResidentTypeList(estateId, {
    page: currentPage,
  })

  useFormik({
    initialValues: {
      title: '',
      price: 0,
      description: '',
    },
    validationSchema: createResidentTypeSchema,
    onSubmit: (values, { resetForm }) => {
      handleCreateResidentType(values, resetForm)
    },
  })

  const handleCreateResidentType = async (
    values: { title: string; price: number; description: string },
    resetForm: () => void
  ) => {
    if (isLoading) return

    setIsLoading(true)
    try {
      const response = await ResidentService.addResidentType(estateId, {
        title: values.title,
        price: values.price,
        description: values.description,
      })
      showToast({
        title: 'Resident Type Created',
        description: response.description || 'Successfully created',
        status: 'success',
        id: 'create-resident-type-success',
      })
      setIsModalOpen(false)
      resetForm()
      mutate()
    } catch (error: any) {
      showToast({
        title: 'Error',
        description: error.message || 'Failed to create resident type',
        status: 'error',
        id: 'create-resident-type-error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  // const handleModalClose = () => {
  //   setIsModalOpen(false)
  //   formik.resetForm()
  // }

  const handleEdit = (residentType: ResidentTypeDTO) => {
    setEditingResidentType(residentType)
    setIsEditModalOpen(true)
  }

  const handleEditModalClose = () => {
    setIsEditModalOpen(false)
    setEditingResidentType(null)
  }

    // const skeletonRows = Array.from({ length: 5 }, (_, index) => (
    //   <SkeletonTable key={index} />
    // ))


  return (
    <div className="mt-4 grid gap-y-10">
      <AddButton
        buttonStyle="w-full sm:w-[248px]"
        handleModalOpen={() => setIsAddModalOpen(true)}
        icon={<img src={addIcon} alt="Add icon" />}
      >
        <p className="text-base font-medium">Add resident type</p>
      </AddButton>

      <CustomTable>
        <CustomTableHead dataList={tableHeadData} />
        {data?.results.length === 0 ? (
          <div className="flex flex-col gap-5 justify-center items-center h-96 w-auto">
            <Empty />
            <p className="text-sm font-semibold">No results found</p>
          </div>
        ) : (
          <CustomTableBody loading={isLoading}>
            {data?.results.map((userData: ResidentTypeDTO) => (
              <CustomTableRow key={userData.id}>
                <CustomTableData dataLabel="Resident type" text={userData.title || ''} />
                <CustomTableData dataLabel="Levy" text={String(userData.price) || ''} />
                <CustomTableData
                  dataLabel="Description"
                  text={userData.description || ''}
                />
                <CustomTableData
                  dataLabel="No of Residents"
                  text={userData.noOfResident || 0}
                />
                <CustomTableDataCTA dataLabel={'Actions'} text={'...'}>
                  <p className="hover:bg-gray-200 p-3 border-t">Disable ResidentType</p>
                  <p className="hover:bg-gray-200 p-3 border-t text-red-500">
                    Remove ResidentType
                  </p>
                  <p
                    className="hover:bg-gray-200 p-3 border-t"
                    onClick={() => handleEdit(userData)}
                  >
                    Edit/View Details
                  </p>
                </CustomTableDataCTA>
              </CustomTableRow>
            ))}
          </CustomTableBody>
        )}
      </CustomTable>

      {isAddModalOpen && (
        <AddResidentType
          estateId={estateId}
          onClose={() => setIsAddModalOpen(false)}
          mutate={mutate}
        />
      )}

      {editingResidentType && (
        <Modal
          open={isEditModalOpen}
          close={handleEditModalClose}
          widthClass="w-[calc(100%-32px)] sm:max-w-lg md:max-w-[776px]"
          modalClassName="p-4 sm:p-6 md:p-8 max-h-[90vh] overflow-y-auto flex flex-col"
        >
          <ModalClose onClick={handleEditModalClose} />
          <EditResidentType
            residentType={editingResidentType}
            estateId={estateId}
            onClose={handleEditModalClose}
            refetch={mutate}
          />
        </Modal>
      )}
    </div>
  )
}

export default ResidentType
